import PropTypes from "prop-types";
import React from "react";
import { reduxForm } from "redux-form";
import { Button } from "cxa-components";
import { SelectField } from "cxa-form-field";
import { intlShape, injectIntl } from "react-intl";
import messages from "components/messagesDescription";
import { intlFormat } from "i18n/util";

const WellnessPrioritiesForm = ({
  initialValues,
  handleSubmit,
  handleOnChange,
  submitting,
  error,
  intl,
  data,
  headerMessage,
  displayMessage,
  riskFactorList,
}) =>
  data
    ? <article className="card">
        <header>
          <h3>
            {intlFormat(intl, { id: headerMessage })}
          </h3>
        </header>
        <p>
          {intlFormat(intl, { id: displayMessage })}
        </p>
        <form onSubmit={handleSubmit}>
          {data.map(priority =>
            <SelectField
              label={intlFormat(intl, { id: priority.fieldLabel })}
              key={priority.id}
              name={priority.id}
              onChange={handleOnChange}
              items={riskFactorList.map(item => ({
                value: item.id,
                label: intlFormat(intl, { id: item.value }),
              }))}
            />
          )}
          {error
            ? <p>
                {intlFormat(intl, { id: error })}
              </p>
            : null}
          <Button primary submitting={submitting}>
            {intl.formatMessage(messages.submitTextDescription)}
          </Button>
        </form>
      </article>
    : null;

WellnessPrioritiesForm.propTypes = {
  initialValues: PropTypes.object,
  handleSubmit: PropTypes.func,
  handleOnChange: PropTypes.func,
  submitting: PropTypes.bool,
  submitted: PropTypes.bool,
  error: PropTypes.string,
  intl: intlShape.isRequired,
  fetched: PropTypes.bool,
  headerMessage: PropTypes.string,
  displayMessage: PropTypes.string,
  riskFactorList: PropTypes.array,
  data: PropTypes.array,
};

export default injectIntl(
  reduxForm({
    form: "wellnessPriorities",
  })(WellnessPrioritiesForm)
);



// WEBPACK FOOTER //
// ./components/wellness/lifestyleAgeing/results/WellnessPrioritiesForm.js